import store from 'app-store';
import { useQuery, useQueryClient } from 'react-query';
import { SET } from './action-types';
import Company from 'services/data/company';
import Agreement from 'services/data/agreement';
import Form from 'services/data/form';
import Watch from 'services/data/watch';
import Person from 'services/data/person';
import WorkOrder from 'services/data/work-order';
import _ from 'lodash';

// Action creators
export function set(data) {
  store.dispatch({
    type: SET,
    data
  });
}

export function useCompany(id, queryOptions = {}, params = {}) {
  const key = ['company', id];
  const load = params.load || [
    'emailAddresses.billingCompanies',
    'phoneNumbers',
    'addresses',
    'billingEmails.contact',
    'defaultAgreement',
    'team',
    'primaryTech',
    'parentCompany'
  ];

  const queryClient = useQueryClient();
  const queryData = useQuery(key, () => Company.findOne(id, { load }), queryOptions);

  return { ...queryData, refetch: () => queryClient.refetchQueries(key) };
}

export function useCompanyAgreements(id, queryOptions = {}) {
  return useQuery(['company', id, 'agreements'], () => Agreement.find({ where: { company: id } }), queryOptions);
}

export function useCompanyPeople(id, queryOptions = {}) {
  const personLoad = ['primaryEmail', 'phoneNumbers', 'emailAddresses'];
  const personWhere = { company: id, status: { in: ['Disabled', 'Active'] } };
  return useQuery(['company', id, 'people'], () => Person.find({ where: personWhere, load: personLoad }), queryOptions);
}

export function useCompanyForms(id, queryOptions = {}) {
  return useQuery(['company', id, 'forms'], () => Form.find(_.defaults({ where: { company: id } }, Form.defaultQuery)), queryOptions);
}

export function useCompanyWatches(id, queryOptions = {}) {
  const key = ['company', id, 'watches'];

  const queryClient = useQueryClient();
  const queryData = useQuery(key, () => Watch.find({ where: { company: id } }), queryOptions);

  return { ...queryData, setQueryData: data => queryClient.setQueryData(key, data) };
}

export function useCompanyWorkOrders(id, queryOptions = {}, where = {}) {
  const query = { where: { company: id, ...where }, ...WorkOrder.defaultQuery };

  return useQuery(['company', id, 'workOrders'], () => WorkOrder.find(query), queryOptions);
}



// WEBPACK FOOTER //
// ./app/routes/company/store/actions.js